jQuery(document).ready(function ($) {
    const rangeInput = document.querySelectorAll(".range-input input"),
        priceInput = document.querySelectorAll(".price-input input"),
        range = document.querySelector(".slider .progress");
    let priceGap = 1000;

    priceInput.forEach((input) => {
        input.addEventListener("input", (e) => {
            let minPrice = parseInt(priceInput[0].value),
                maxPrice = parseInt(priceInput[1].value);

            if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
                if (e.target.className === "input-min") {
                    rangeInput[0].value = minPrice;
                    range.style.left = (minPrice / rangeInput[0].max) * 100 + "%";
                } else {
                    rangeInput[1].value = maxPrice;
                    range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                }
            }
        });
    });

    rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
            let minVal = parseInt(rangeInput[0].value),
                maxVal = parseInt(rangeInput[1].value);

            if (maxVal - minVal < priceGap) {
                if (e.target.className === "range-min") {
                    rangeInput[0].value = maxVal - priceGap;
                } else {
                    rangeInput[1].value = minVal + priceGap;
                }
            } else {
                priceInput[0].value = minVal;
                priceInput[1].value = maxVal;
                range.style.left = (minVal / rangeInput[0].max) * 100 + "%";
                range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
            }
        });
    });

    function renderRangeInputProcess() {
        if (priceInput.length === 0) {
            return;
        }
        let minPrice = parseInt(priceInput[0].value),
            maxPrice = parseInt(priceInput[1].value);

        if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
            rangeInput[0].value = minPrice;
            range.style.left = (minPrice / rangeInput[0].max) * 100 + "%";

            rangeInput[1].value = maxPrice;
            range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
        }
    }
    renderRangeInputProcess();

    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('btn-filter-price')) {
            fetchCollection();
        }

        if (
            (e.target.classList.contains('wrapper-collections-list-product__sort--select__choice')
                || e.target.closest('.wrapper-collections-list-product__sort--select__choice'))
            && !e.target.classList.contains('wrapper-collections-list-product__sort--select__options')
        ) {
            const options = document.querySelector('.wrapper-collections-list-product__sort--select__options')
            const icon = document.querySelector('.wrapper-collections-list-product__sort--select__choice--icon')

            if (options) {
                if (options.classList.contains('active')) {
                    options.classList.remove('active');
                    icon.classList.remove('active');
                } else {
                    options.classList.add('active');
                    icon.classList.add('active');
                }
            }
        }

        if (e.target.classList.contains('wrapper-collections-list-product__sort--select__options--item')) {
            const options = document.querySelector('.wrapper-collections-list-product__sort--select__options')
            const choice = document.querySelector('.wrapper-collections-list-product__sort--select__choice--value span')
            const choiceText = e.target.innerText;
            const dataValue = e.target.getAttribute('data-value');
            const icon = document.querySelector('.wrapper-collections-list-product__sort--select__choice--icon')

            if (options) {
                if (options.classList.contains('active')) {
                    options.classList.remove('active');
                    icon.classList.remove('active');
                } else {
                    options.classList.add('active');
                    icon.classList.add('active');
                }
            }

            if (choice) {
                choice.innerText = choiceText;
                choice.setAttribute('data-value', dataValue);

                fetchCollection();
            }
        }

        if (
            e.target.classList.contains('wrapper-collections-list-product__filter--title')
            || e.target.closest('.wrapper-collections-list-product__filter--title')
            || e.target.classList.contains('collections-sidebar__collections--head__close')
            || e.target.closest('.collections-sidebar__collections--head__close')
            || e.target.classList.contains('overload-page')) {
            toggleFilter();
        }

        if (e.target.classList.contains('collections-sidebar__collections--head__clear')) {
            const filterCollections = document.querySelectorAll('.filter-collection');
            filterCollections.forEach((filter) => {
                filter.checked = false;
            });
            fetchCollection();
        }

    })

    document.addEventListener('change', function (e) {
        if (e.target.classList.contains('filter-collection')) {
            fetchCollection();
        }
    })

    function toggleFilter() {
        const filter = document.querySelector('#filter_sidebar')
        if (filter) {
            filter.classList.toggle('active');
        }
        const sitePage = document.querySelector('.site-page')
        if (sitePage) {
            sitePage.classList.toggle('overload-page');
        }
    }

    function fetchCollection() {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        params.delete('prices')
        let minPrice = '',
            maxPrice = '';

        if (priceInput.length > 0) {
            minPrice = parseInt(priceInput[0].value);
            maxPrice = parseInt(priceInput[1].value);
            params.append('prices', minPrice + ',' + maxPrice);
        }

        const filterCollections = document.querySelectorAll('.filter-collection');
        let arrFilter = [];
        filterCollections.forEach((filter) => {
            if (filter.checked) {
                arrFilter.push(filter.value);
            }
        });

        if (arrFilter.length > 0) {
            params.delete('filters');
            params.append('filters', arrFilter.join(','));
        }

        // orderBy with price 
        const choiceSort = document.querySelector('.wrapper-collections-list-product__sort--select__choice--value span')
        if (choiceSort) {
            params.delete('orderBy');
            params.append('orderBy', 'price.' + choiceSort.getAttribute('data-value'));
        }

        $.ajax({
            url: `${url.origin}${url.pathname}${params.toString() ? '?' + params.toString() : ''}`,
            type: "GET",
            success: function (response) {
                if (response.success) {
                    const wrapperCollectionsListProduct = document.querySelector('.wrapper-collections-list-product__body')
                    if (wrapperCollectionsListProduct) {
                        wrapperCollectionsListProduct.innerHTML = response.html;
                    }
                }
            },
            error: function (error) {
                console.log(error);
            }
        });
    }
})
